import { render } from "./sceneBox.vue?vue&type=template&id=2fbd1dfa&scoped=true&ts=true&lang=pug"
import script from "./sceneBox.vue?vue&type=script&lang=ts"
export * from "./sceneBox.vue?vue&type=script&lang=ts"

import "./sceneBox.vue?vue&type=style&index=0&id=2fbd1dfa&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbd1dfa"]])

export default __exports__